import { useEffect } from 'react';

type Handler = (event: KeyboardEvent) => void;

export interface Shortcut {
  key: string;           // lowercase
  handler: Handler;
  allowInInput?: boolean;
  modifier?: 'meta';     // requires Cmd (mac) or Ctrl (win/linux)
}

export function useKeyboard(shortcuts: Shortcut[]): void {
  useEffect(() => {
    const onKey = (e: KeyboardEvent): void => {
      if (e.altKey) return;
      // Sous un dialogue, plus de raccourci global : `t` ne change pas de page derrière une
      // modale, et surtout `Escape` n'est pas annulé ici — il appartient au <dialog> natif, qui
      // ne reçoit pas `cancel` pour une touche dont on a empêché l'action (ui/Dialogue.tsx).
      if (document.querySelector('dialog[open]')) return;
      const hasMeta = e.metaKey || e.ctrlKey;
      const target = e.target as HTMLElement | null;
      const inInput =
        !!target &&
        (target.tagName === 'INPUT' ||
          target.tagName === 'TEXTAREA' ||
          target.isContentEditable);

      for (const s of shortcuts) {
        if (s.modifier === 'meta' && !hasMeta) continue;
        if (!s.modifier && hasMeta) continue;
        if (s.key !== e.key.toLowerCase()) continue;
        if (inInput && !s.allowInInput) continue;
        e.preventDefault();
        s.handler(e);
        break;
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [shortcuts]);
}
